<template>
	<div class="profile-menstruation" id="js_dataList">
		<!-- ローディング -->
		<transition name="fade">
			<redraw-progress v-if="isLoading" />
		</transition>
		<!-- /ローディング -->
		<div v-if="contentsDisplayBoolean" class="profile-menstruation__contents">
			<div class="profile-menstruation-plans">
				<div class="profile-menstruation-plans__heading">
					<span class="profile-menstruation-plans__heading--text">生理</span>
					<a href="native://open_menstruation_setting" class="profile-menstruation-plans__heading--setting sprite-menstruation profile_setting" />
				</div>
				<div class="profile-menstruation-plans__contents">
					<div class="profile-menstruation-plans__contents--date">
						<span class="profile-menstruation-plans__contents--date-future">生理予定日</span>
						<span class="profile-menstruation-plans__contents--date-dating">{{ plansDateDating }}</span>
						<span class="profile-menstruation-plans__contents--date-week">{{ plansDateWeek }}</span>
					</div>
					<div class="profile-menstruation-plans__contents--after">
						<a :href="expectedDisplayBoolean ? 'native://open_menstruation_setting' : 'javascript:void(0);'" class="profile-menstruation-plans__contents--after-anchor">{{ plansAfter }}</a>
					</div>
				</div>
			</div>
			<!-- TODO: 生理日一覧部分は今後必要に応じてコンポーネント化を検討 -->
			<div v-if="menstruationDataList && menstruationDataList.length > 0" class="profile-menstruation-history">
				<div class="profile-menstruation-history__heading">
					<span class="profile-menstruation-history__heading--history">履歴</span>
					<span class="profile-menstruation-history__heading--period">期間</span>
					<span class="profile-menstruation-history__heading--cycle">周期</span>
				</div>
				<div class="profile-menstruation-history__contents">
					<ul class="profile-menstruation-history__contents--list">
						<li v-for="(menstruationDataItem, index) in menstruationDataList" class="profile-menstruation-history__contents--item" :key="index">
							<a :href="menstruationDataItem.from_time ? `native://openGraph?at=${menstruationDataItem.from_time}` : 'javascript:void(0)'" class="profile-menstruation-history__contents--anchor">
								<span class="profile-menstruation-history__contents--anchor-history"><i class="profile-menstruation-history__contents--anchor-start sprite-menstruation profile_start" />{{ menstruationDataItem.history_date }}</span>
								<span class="profile-menstruation-history__contents--anchor-period">{{ menstruationDataItem.term }}</span>
								<span class="profile-menstruation-history__contents--anchor-cycle">{{ menstruationDataItem.cycle }}</span>
							</a>
						</li>
					</ul>
					<a v-if="isReadmore" href="native://open_menstruation_history" class="profile-menstruation-history__contents--readmore">もっと見る</a>
					<div v-else class="profile-menstruation-empty"/>
				</div>
			</div>
			<div v-else class="profile-menstruation-empty"/>
		</div>
	</div>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PAININPERIOD_DATA } from '../../store/modules/painNote/mutation-types'
import { SET_MENSTRUATION_DATA } from '../../store/modules/menstruation/mutation-types'

// Compornents
import RedrawProgress from '../../components/Molecules/RedrawProgress'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'ProfileMenstruation',
	components: {
		RedrawProgress
	},
	data () {
		return {
			painFirstData: null,
			contentsDisplayBoolean: false,
			expectedDisplayBoolean: false,
			plansDateDating: '',
			plansDateWeek: '',
			plansAfter: '',
			menstruationDataList: null,
			isReadmore: false,
			isLoading: false
		}
	},
	mounted () {
		this.getPainperiodData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken', 'userData', 'premiumType']),
		...mapGetters('painNote', ['painInperiodData']),
		...mapGetters('menstruation', ['menstruationData'])
	},

	methods: {
		// map Vuex actions
		...mapActions('painNote', [SET_PAININPERIOD_DATA]),
		...mapActions('menstruation', [SET_MENSTRUATION_DATA]),

		/**
		 * 痛み記録データ取得(期間)処理
		 */
		getPainperiodData () {
			// HACK: 痛み記録を生理日記録の開始日指定のためだけに取得しているっぽいので大規模改修のタイミングでリファクタリングしたい。
			// HACK: パフォーマンスを気にして「記録可能な最も古い期間」から「ユーザー登録日」の痛み記録をとって生理記録の検索開始日時にしているが、そもそも痛み記録をとらなくても生理記録の検索開始日時を「記録可能な最も古い期間」にしても良さそう（月1記録があるとして10年でも120レコードなのでパフォーマンス的にも悪くなさそう）。
			// NOTE: ユーザー登録後、過去にさかのぼって記録をつけたケースに対応するため、ユーザー登録日の前に痛み記録が存在するかのチェック
			// TODO: 記録可能な最も古い期間が何故2015/12/1なのかの根拠について要調査
			const firstDate = 1448895600	// NOTE: 記録可能な最も古い期間（2015-12-01 00:00:00）
			const insertDate = this.userData.insert_date.sec // NOTE: ユーザの登録日
			const includeRiseWarning = 1 // NOTE: 気圧アラート取得のフラグを立てる, webviewのため1

			if (firstDate < insertDate) {	// 「記録可能な最も古い期間」のあとにユーザーが登録しているケース
				this.SET_PAININPERIOD_DATA({
					user_id: this.userId,
					user_token: this.userToken,
					from: firstDate,
					to: insertDate,
					include_rise_warning: includeRiseWarning
				}).then(res => {
					this.painFirstData = this.painInperiodData.records.map(item => {
						return {
							'date': item.hour.sec
						}
					}).slice(0, 1)[0]

					this.getMenstruationData()
				}).catch(error => {
					console.log(error)
					// NOTE: エラーが起こった場合、登録日の前に痛み記録はないと見なして登録日を基点に生理記録を取得する
					this.getMenstruationData()
				})
			} else {	// 「記録可能な最も古い期間」以前にユーザーが登録しているケース
				// NOTE: このケースでAPIにリクエストするとエラーになりcatchに入るためなくても動作するが、リクエストを減らす意味で実装しています
				this.getMenstruationData()
			}
		},

		/**
		 * 生理日記録データ取得(件数)処理
		 */
		getMenstruationData () {
			// HACK: このメソッドの処理が煩雑すぎるので大規模改修のタイミングでリファクタリングしたい。
			// TODO: this.userDataの判定をしているところとしていないところが混在している。また、現状の実装だとuserDataがエラーで取れなければundefinedになるのでJSエラーが発生する。本コンポーネントではないがAPIのgetuser.jsonのレスポンスで200OKでもエラーのケースがあるが考慮されていないので改修する必要がある。
			const insertDate = this.painFirstData ? this.painFirstData.date : this.userData.insert_date.sec // NOTE: 最初の痛み記録 or ユーザの登録日
			const endOfThisMonth = moment().add(30, 'days').unix() // NOTE: 現在の日付+30日（データ取得件数によるレスポンス量の多さを考慮して30日と設定、生理予定日が30日を超える場合の処理は「生理予定日のunixタイム」にて処理）
			const menstruationDataItemNum = 3 // NOTE: 表示する生理記録の数

			this.SET_MENSTRUATION_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				from: insertDate,
				to: endOfThisMonth
			}).then(res => {
				const menstruationDataList = this.menstruationData.records.map((item, index, array) => {
					return {
						'from_time': item.from_time.sec,
						'history_date': moment.unix(item.from_time.sec).format('YYYY年M月D日（ddd）～'),
						'term': `${moment.unix(item.term).diff(0, 'days')}日`,
						'cycle': index !== 0 ? `${moment.unix(array[index].from_time.sec).diff(moment.unix(array[index - 1].from_time.sec), 'days')}日` : '-',
						'is_expected': item.is_expected
					}
				})

				// NOTE: 表示出し分けに必要な情報
				// 表示出し分けに必要な情報の定義はWebviewProfileMenstruationTopで行う方がキレイそう、今後の実装次第で要検討
				// 女性フラグ（sex「1: 男性, 2: 女性, 3: 未回答」）
				const isFemale = this.userData && (this.userData.sex === '2' || this.userData.sex === 2)
				// 生理日記録機能ONフラグ（menstruation.enabled「0: 無効、1: 有効」）
				// CHANGE: ユーザー情報に生理日記録データがない場合（プロフィール登録のみで生理日設定をしていないケース）はデフォルト値を扱うよう変更
				// const isEnabled = this.userData && this.userData.menstruation && (this.userData.menstruation.enabled === '1' || this.userData.menstruation.enabled === 1)
				const DEFAULT_MENSTRUATION_SETTING = {	// 生理記録設定データが存在しないときに使用する設定
					'interval': null,
					'term': null,
					'enabled': '1'
				}
				const userDataMenstruation = (this.userData && this.userData.menstruation && typeof this.userData.menstruation !== 'undefined') ? this.userData.menstruation : DEFAULT_MENSTRUATION_SETTING
				const isEnabled = userDataMenstruation.enabled === '1' || userDataMenstruation.enabled === 1
				// プレミアムユーザーフラグ
				const isPremium = this.premiumType && this.premiumType.premium_type_code > 1

				// NOTE: 無料開放後の表示出し分けパターン
				/**
				 * A: 女性以外（なにも表示しない）
				 * B: 女性 and 生理日記録機能ON（生理日記録機能表示）
				 * C: 女性 and 生理日記録機能OFF（なにも表示しない ※今後なにかしら表示する可能性あり）
				 */
				let isDisplayType = ''
				if (!isFemale) {
					isDisplayType = 'A'
				} else if (isFemale && !isEnabled) {
					isDisplayType = 'C'
				} else {
					isDisplayType = 'B'
				}
				console.log('isPremium: ', isPremium)
				console.log('isDisplayType: ', isDisplayType)
				console.log('userDataMenstruation: ', userDataMenstruation)

				// NOTE: 生理日記録機能表示の有無
				if (isDisplayType === 'B') this.contentsDisplayBoolean = true

				// NOTE: 履歴のデータ一覧
				const menstruationHistoryDataList = menstruationDataList.filter(item => {
					// NOTE: 生理日記録の無料開放対応で痛み記録がない場合、無料ユーザーはユーザの登録日ではなく90日以前を基点に取得するよう変更（無料ユーザーは90日以前の気圧グラフに遷移できないため）。
					if (!isPremium) {
						return !item.is_expected && item.from_time >= moment().add(-90, 'days').unix()
					} else {
						return !item.is_expected
					}
				}).reverse()
				console.log('menstruationHistoryDataList: ', menstruationHistoryDataList)

				this.menstruationDataList = menstruationHistoryDataList.slice(0, menstruationDataItemNum)

				// NOTE: 「もっと見る」表示フラグ
				this.isReadmore = menstruationHistoryDataList.length > menstruationDataItemNum

				// NOTE: 生理日記録データ・ユーザーデータ両方の周期の有無
				this.expectedDisplayBoolean = !!this.menstruationDataList.length && !!userDataMenstruation.interval

				// NOTE: 生理予定日のデータ
				// is_expected「生理予測日フラグ」を持つ配列が複数存在する場合を考慮し、生理予定日の配列の1つ目（履歴の最新データの次のデータ）を予定日とする
				// NOTE: 生理予定日の配列の1つ目（履歴の最新データの次のデータ）を予定日としているが、その予定日が現在日時より古い場合でもそのまま表示するのが現状の仕様。
				const menstruationFeatureData = menstruationDataList.filter(item => {
					return item.is_expected
				}).slice(0, 1)[0]

				// NOTE: 生理予定日のunixタイム
				// is_expected「生理予測日フラグ」を持つ配列が存在しない場合は最新の履歴日+ユーザデータの周期、存在する場合は生理予定日とする
				// NOTE: 無料開放で「生理予測日フラグ」を持つ配列が存在するが、履歴データがない場合が発生する。データがない場合「-」表示にする（確認済み）。
				const plansDate = this.expectedDisplayBoolean ? (menstruationFeatureData === undefined ? moment.unix(this.menstruationDataList[0].from_time).add(userDataMenstruation.interval, 'days') : moment.unix(menstruationFeatureData.from_time)) : ''

				// NOTE: 生理予定日関連データ
				this.plansDateDating = this.expectedDisplayBoolean ? plansDate.format('M/D') : '-'
				this.plansDateWeek = this.expectedDisplayBoolean ? plansDate.format('（ddd）') : '（-）'
				this.plansAfter = this.expectedDisplayBoolean && plansDate.diff(moment(new Date()), 'days') > 0 ? `あと${plansDate.diff(moment(new Date()), 'days')}日` : this.expectedDisplayBoolean ? 'あと0日' : '-'
			}).catch(error => {
				// TODO: エラー処理
				console.log(error)
			})
		}
	}
}
</script>
